export default __webpack_public_path__ + "static/media/other.bc1c38f9.svg";